// fetch forex deposits
export const FETCH_CREDITS_REQUESTED = "FETCH_CREDITS_REQUESTED";
export const FETCH_CREDITS_SUCCESS = "FETCH_CREDITS_SUCCESS";
export const FETCH_CREDITS_FAIL = "FETCH_CREDITS_FAIL";

export const ADD_CREDIT_REQUESTED = "ADD_CREDIT_REQUESTED";
export const ADD_CREDIT_SUCCESS = "ADD_CREDIT_SUCCESS";
export const ADD_CREDIT_FAIL = "ADD_CREDIT_FAIL";
export const ADD_CREDIT_CLEAR = "ADD_CREDIT_CLEAR";
export const ADD_CREDIT_ERROR_CLEAR = "ADD_CREDIT_ERROR_CLEAR";